import React, { useState, useEffect, useContext } from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { EyeClosed } from '@blueprintnyc/bpnyc-common-admin/dist/icons';
import { TbCopy, TbX } from 'react-icons/tb';
import WidgetPreviews from 'components/WidgetPreviews';
import PhoneScreen from 'components/PhoneScreen/PhoneScreen';
import { WidgetContext } from '@/WidgetContextProvider';
import { getVisibleWidgets, getWidgetKey } from '@/redux/reducers/widget.reducer';

const rowActionIconProps = { size: 16, strokeWidth: 2.5 };

const WidgetDevicePreview = props => {
	const {
		widgets,
		handleWidgetDelete,
		handleWidgetUpdate,
		onDelete,
		onDuplicate,
		event,
		theme,
	} = props;
	const [width, setWidth] = useState();
	const { previewerRef } = useContext(WidgetContext);

	useEffect(() => {
		setWidth(previewerRef.current.clientWidth);
	}, []);

	const bgStyle =
		theme && theme.background_src
			? { backgroundImage: `url(${theme.background_src})` }
			: { backgroundColor: theme.background_color || '#FFFFFF' };
	const visibleWidgets = getVisibleWidgets(widgets);

	return (
		<div className="WidgetDevicePreview" ref={previewerRef} style={{ width: '100%' }}>
			<div style={{ flex: 1, height: '100%' }}>
				<PhoneScreen theme={event.theme} divClassName="WidgetPhoneScreen">
					<Droppable droppableId="previewer">
						{(provided, snapshot) => (
							<>
								<div
									ref={provided.innerRef}
									{...provided.droppableProps}
									style={{
										...bgStyle,
										overflowY: 'scroll',
										height: '100%',
										backgroundSize: 'cover',
										backgroundRepeat: 'no-repeat',
										backgroundPosition: 'center',
									}}
								>
									{visibleWidgets.length ? (
										visibleWidgets.map((widget, index) => {
											const widgetKey = getWidgetKey(widget);
											return (
												<Draggable key={widgetKey} draggableId={widgetKey} index={index}>
													{(provided, snapshot) => (
														<div
															className="widget-row"
															ref={provided.innerRef}
															{...provided.draggableProps}
															{...provided.dragHandleProps}
															onClick={() => handleWidgetUpdate(widget)}
														>
															<div className="actions-hover-wrap">
																{widget.groups.length ? (
																	<div className="groups-icon">
																		<EyeClosed />
																	</div>
																) : null}
																<div className="row-actions">
																	<button
																		type="button"
																		title="Duplicate"
																		aria-label="Duplicate"
																		onClick={e => onDuplicate(e, widgetKey)}
																	>
																		<TbCopy {...rowActionIconProps} />
																	</button>
																	<button
																		type="button"
																		title="Delete"
																		aria-label="Delete"
																		onClick={e => onDelete(e, widgetKey)}
																	>
																		<TbX {...rowActionIconProps} />
																	</button>
																</div>
																<div style={{}}>
																	<WidgetPreviews
																		type={widget.type}
																		handleDelete={handleWidgetDelete}
																		deviceWidth={width}
																		item={widget || {}}
																		style={{ color: theme.widgets_color }}
																	/>
																</div>
															</div>
														</div>
													)}
												</Draggable>
											);
										})
									) : (
										<div className="NoWidgetsMessage">
											Drag the widgets here to create your custom page
										</div>
									)}
									{provided.placeholder}
								</div>
							</>
						)}
					</Droppable>
				</PhoneScreen>
			</div>
		</div>
	);
};

export default WidgetDevicePreview;
